import React from 'react'
import './PlanDetailSectionTitle.css'

function PlanDetailSectionTitle({ text, className }) {
    return <h2 className={`planDetailSectionTitle ${className}`}>{text}</h2>
}

export default PlanDetailSectionTitle
